<div #chatContainer class="chat-container sf-chat-override"></div>

@if (!chatReady$()) {
  <div class="chat-loader">
    <mat-spinner [diameter]="32" [strokeWidth]="4" [color]="'black'" />
  </div>
}
